import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M20.182 1.702c1.167 0 2.113.947 2.113 2.113V20.18a2.114 2.114 0 0 1-2.113 2.114H3.818a2.114 2.114 0 0 1-2.113-2.114V3.815c0-1.166.946-2.113 2.113-2.113zM11.25 12.747H3.204v7.432c0 .305.223.558.515.606l.1.008 7.43-.001v-8.045zm9.545 0H12.75v8.045h7.432a.614.614 0 0 0 .605-.513l.008-.1v-7.432zM11.25 3.2H3.818a.614.614 0 0 0-.613.614l-.001 7.432h8.046V3.2zm8.932 0H12.75v8.046h8.045V3.815a.614.614 0 0 0-.514-.605l-.1-.008z' />
  </svg>
);
